// This file exports the Stimulus application for use by other modules
// The actual controller loading happens in index.js

import { Application } from "stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }